import { ReactElement, useEffect, useState } from 'react';
import { DocCompareChunkFinderChunk } from '~/api/def/endpoints/docCompare/docCompareChunkFinderEndpoint';
import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { SearchResultContainer } from '~/components/ui/globalSearch/SearchResultContainer';

// Extend the DocCompareChunkFinderChunk interface to include the _originalFund property
interface ExtendedDocCompareChunkFinderChunk
  extends DocCompareChunkFinderChunk {
  _originalFund?: FundGetData;
}

export type SearchResultsProps = {
  results: ExtendedDocCompareChunkFinderChunk[] | null;
  onResultClick?: (result: ExtendedDocCompareChunkFinderChunk) => void;
  onClose?: () => void;
};
/**
 * SearchResults component renders list of search results
 * @param results
 * @param onResultClick Optional callback when a result is clicked
 * @param onClose Optional callback to close the search box
 */
export const SearchResults = ({
  results,
  onResultClick,
  onClose,
}: SearchResultsProps) => {
  const [resItems, setResItems] = useState<ReactElement[]>([]);

  useEffect(() => {
    if (results) {
      const renderResults = results.map((result) => {
        return (
          <div
            key={result.id}
            onClick={() => onResultClick && onResultClick(result)}
            style={{ cursor: onResultClick ? 'pointer' : 'default' }}
          >
            <SearchResultContainer result={result} onClose={onClose} />
          </div>
        );
      });
      setResItems(renderResults);
    } else {
      setResItems([]);
    }
  }, [results, onResultClick, onClose]);

  if (!results) return null;
  return <div className="w-full flex flex-column gap-3">{resItems}</div>;
};
